import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_2af8009a from 'nuxt_plugin_plugin_2af8009a' // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_sentryserver_1f1972ae from 'nuxt_plugin_sentryserver_1f1972ae' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_8d3ffdb4 from 'nuxt_plugin_sentryclient_8d3ffdb4' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_apollomodule_48ea7eb6 from 'nuxt_plugin_apollomodule_48ea7eb6' // Source: ./apollo-module.js (mode: 'all')
import nuxt_plugin_axios_12163cea from 'nuxt_plugin_axios_12163cea' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_utils_3336a20a from 'nuxt_plugin_utils_3336a20a' // Source: ../plugins/utils (mode: 'all')
import nuxt_plugin_snack_03566c5f from 'nuxt_plugin_snack_03566c5f' // Source: ../plugins/snack.js (mode: 'all')
import nuxt_plugin_routes_79dccfb7 from 'nuxt_plugin_routes_79dccfb7' // Source: ../plugins/routes.js (mode: 'all')
import nuxt_plugin_moment_57893d7e from 'nuxt_plugin_moment_57893d7e' // Source: ../plugins/moment.js (mode: 'all')
import nuxt_plugin_dialog_80887e0e from 'nuxt_plugin_dialog_80887e0e' // Source: ../plugins/dialog.js (mode: 'all')
import nuxt_plugin_dbHelpers_419206e6 from 'nuxt_plugin_dbHelpers_419206e6' // Source: ../plugins/dbHelpers.js (mode: 'all')
import nuxt_plugin_placements_7d46655a from 'nuxt_plugin_placements_7d46655a' // Source: ../plugins/placements.js (mode: 'all')
import nuxt_plugin_timesheets_4c9bcea0 from 'nuxt_plugin_timesheets_4c9bcea0' // Source: ../plugins/timesheets.js (mode: 'all')
import nuxt_plugin_index_17a7da76 from 'nuxt_plugin_index_17a7da76' // Source: ../plugins/history/index.js (mode: 'all')
import nuxt_plugin_handleError_17356ba6 from 'nuxt_plugin_handleError_17356ba6' // Source: ../plugins/handleError.js (mode: 'all')
import nuxt_plugin_validation_7d99b1b0 from 'nuxt_plugin_validation_7d99b1b0' // Source: ../plugins/validation.js (mode: 'all')
import nuxt_plugin_globalComponents_61ab9908 from 'nuxt_plugin_globalComponents_61ab9908' // Source: ../plugins/globalComponents.js (mode: 'all')
import nuxt_plugin_firebase_34d6f55a from 'nuxt_plugin_firebase_34d6f55a' // Source: ../plugins/firebase.js (mode: 'all')
import nuxt_plugin_dbWatchers_85905d68 from 'nuxt_plugin_dbWatchers_85905d68' // Source: ../plugins/dbWatchers.js (mode: 'all')
import nuxt_plugin_userAuth_eed78864 from 'nuxt_plugin_userAuth_eed78864' // Source: ../plugins/userAuth.js (mode: 'all')
import nuxt_plugin_axios_5659d192 from 'nuxt_plugin_axios_5659d192' // Source: ../plugins/axios.js (mode: 'client')
import nuxt_plugin_cookies_2c3cf8fe from 'nuxt_plugin_cookies_2c3cf8fe' // Source: ../plugins/cookies.js (mode: 'client')
import nuxt_plugin_VuexPersistence_7d45a137 from 'nuxt_plugin_VuexPersistence_7d45a137' // Source: ../plugins/VuexPersistence (mode: 'client')
import nuxt_plugin_smoothResize_3e7a687f from 'nuxt_plugin_smoothResize_3e7a687f' // Source: ../plugins/smoothResize.js (mode: 'client')
import nuxt_plugin_fireAuthState_5f40925a from 'nuxt_plugin_fireAuthState_5f40925a' // Source: ../plugins/fireAuthState.js (mode: 'client')
import nuxt_plugin_globalComponentsClient_1104dc7d from 'nuxt_plugin_globalComponentsClient_1104dc7d' // Source: ../plugins/globalComponentsClient.js (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"slide-x-transition","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Concorde Crisp","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"Concorde Recruitment Online Timesheets"},{"hid":"theme-color","name":"theme-color","content":"#00537F"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Roboto:300,400,500,700|Cabin:300,400,500,700|Material+Icons"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Roboto:100,300,400,500,700,900&display=swap"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002F@mdi\u002Ffont@latest\u002Fcss\u002Fmaterialdesignicons.min.css"}],"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_2af8009a === 'function') {
    await nuxt_plugin_plugin_2af8009a(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_1f1972ae === 'function') {
    await nuxt_plugin_sentryserver_1f1972ae(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_8d3ffdb4 === 'function') {
    await nuxt_plugin_sentryclient_8d3ffdb4(app.context, inject)
  }

  if (typeof nuxt_plugin_apollomodule_48ea7eb6 === 'function') {
    await nuxt_plugin_apollomodule_48ea7eb6(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_12163cea === 'function') {
    await nuxt_plugin_axios_12163cea(app.context, inject)
  }

  if (typeof nuxt_plugin_utils_3336a20a === 'function') {
    await nuxt_plugin_utils_3336a20a(app.context, inject)
  }

  if (typeof nuxt_plugin_snack_03566c5f === 'function') {
    await nuxt_plugin_snack_03566c5f(app.context, inject)
  }

  if (typeof nuxt_plugin_routes_79dccfb7 === 'function') {
    await nuxt_plugin_routes_79dccfb7(app.context, inject)
  }

  if (typeof nuxt_plugin_moment_57893d7e === 'function') {
    await nuxt_plugin_moment_57893d7e(app.context, inject)
  }

  if (typeof nuxt_plugin_dialog_80887e0e === 'function') {
    await nuxt_plugin_dialog_80887e0e(app.context, inject)
  }

  if (typeof nuxt_plugin_dbHelpers_419206e6 === 'function') {
    await nuxt_plugin_dbHelpers_419206e6(app.context, inject)
  }

  if (typeof nuxt_plugin_placements_7d46655a === 'function') {
    await nuxt_plugin_placements_7d46655a(app.context, inject)
  }

  if (typeof nuxt_plugin_timesheets_4c9bcea0 === 'function') {
    await nuxt_plugin_timesheets_4c9bcea0(app.context, inject)
  }

  if (typeof nuxt_plugin_index_17a7da76 === 'function') {
    await nuxt_plugin_index_17a7da76(app.context, inject)
  }

  if (typeof nuxt_plugin_handleError_17356ba6 === 'function') {
    await nuxt_plugin_handleError_17356ba6(app.context, inject)
  }

  if (typeof nuxt_plugin_validation_7d99b1b0 === 'function') {
    await nuxt_plugin_validation_7d99b1b0(app.context, inject)
  }

  if (typeof nuxt_plugin_globalComponents_61ab9908 === 'function') {
    await nuxt_plugin_globalComponents_61ab9908(app.context, inject)
  }

  if (typeof nuxt_plugin_firebase_34d6f55a === 'function') {
    await nuxt_plugin_firebase_34d6f55a(app.context, inject)
  }

  if (typeof nuxt_plugin_dbWatchers_85905d68 === 'function') {
    await nuxt_plugin_dbWatchers_85905d68(app.context, inject)
  }

  if (typeof nuxt_plugin_userAuth_eed78864 === 'function') {
    await nuxt_plugin_userAuth_eed78864(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_axios_5659d192 === 'function') {
    await nuxt_plugin_axios_5659d192(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_cookies_2c3cf8fe === 'function') {
    await nuxt_plugin_cookies_2c3cf8fe(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_VuexPersistence_7d45a137 === 'function') {
    await nuxt_plugin_VuexPersistence_7d45a137(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_smoothResize_3e7a687f === 'function') {
    await nuxt_plugin_smoothResize_3e7a687f(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_fireAuthState_5f40925a === 'function') {
    await nuxt_plugin_fireAuthState_5f40925a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_globalComponentsClient_1104dc7d === 'function') {
    await nuxt_plugin_globalComponentsClient_1104dc7d(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
